export default __webpack_public_path__ + "static/media/dividends.f2ead42a.png";